var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"previous-step__container"},[_c('router-link',{staticClass:"previous-step__link",class:{ 'previous-step__link--hidden': _vm.hidden === true },attrs:{"to":_vm.goToStep}},[_vm._v(_vm._s(_vm.linkText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }